// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Hierarchy_breadcrumb__LECM6 font-sm-regular"};